import { API_MARKETPLACE } from 'Constants/client-modules';
import * as ACTION_TYPES from './types';

export function getMedicineRequest(id) {
  return {
    types: [
      ACTION_TYPES.MEDICINE_REQUEST_DETAIL_REQUESTED,
      ACTION_TYPES.MEDICINE_REQUEST_DETAIL_SUCCEED,
      ACTION_TYPES.MEDICINE_REQUEST_DETAIL_FAILED,
    ],
    promise: client => client.get(`/medicine-requests/${id}`),
    options: {
      clientName: API_MARKETPLACE,
    },
  };
}

export function approveMedicineRequest(id, consultId) {
  return {
    types: [
      ACTION_TYPES.MEDICINE_REQUEST_APPROVE_REQUESTED,
      ACTION_TYPES.MEDICINE_REQUEST_APPROVE_SUCCEED,
      ACTION_TYPES.MEDICINE_REQUEST_APPROVE_FAILED,
    ],
    promise: client => client.post(`/medicine-requests/${id}/approved`, { consultId }),
    options: {
      clientName: API_MARKETPLACE,
    },
  };
}
